@if (animationState$ | async; as animationState) {
  <div
    [@animateBackdrop]="animationState"
    [ngClass]="{ hidden: animationState === 'initial' }"
  class="modal-backdrop"></div>
}
